import { i18n } from '../i18n/translate.js';

var convertTimeDisplay = function convertTimeDisplay(time) {
  var num = parseInt(time);
  var hours = Math.floor(num / 60);
  var minutes = num % 60;

  if (hours > 0 || minutes > 0) {
    var hourString = hours > 0 ? i18n.t('{{hours}} hr', {
      hours: hours
    }) : '';
    var minuteString = minutes > 0 ? i18n.t('{{minutes}} min', {
      minutes: minutes
    }) : '';

    if (hours > 0 && minutes > 0) {
      return "".concat(hourString, " ").concat(minuteString);
    } else if (hours > 0) {
      return hourString;
    } else if (minutes > 0) {
      return minuteString;
    }
  } else {
    return i18n.t('<1 min');
  }
};

var convertTimeDisplayFromSeconds = function convertTimeDisplayFromSeconds(timeInSeconds) {
  var hours = Math.floor(timeInSeconds / 3600);
  var minutes = Math.floor(timeInSeconds % 3600 / 60);
  return i18n.t('{{hours}} hours and {{minutes}} minutes', {
    hours: hours,
    minutes: minutes
  });
};

export { convertTimeDisplay, convertTimeDisplayFromSeconds };